import React, {useEffect, useState} from 'react';
import image from "../../assets/images/auth-bg.svg";
import {CloseButton} from "react-bootstrap";
import {Authenticator} from "@aws-amplify/ui-react";
import {Navigate, useLocation, useSearchParams} from "react-router-dom";
import {DataStore} from "@aws-amplify/datastore";
import {Hub} from "@aws-amplify/core";
import SettingThingsUp from "../ui/SettingThingsUp";

function Login(props) {
    const Heading = () => {
        return <div className="position-relative">
            <img src={image} alt={"Sussd Auth Background Image"}/>

            {props?.onClose && (<CloseButton variant="white" onClick={props.onClose}/>)}
        </div>
    }
    const components = {
        Header: Heading
    };
    // const fields = {
    //     given_name: {
    //         order: 1,
    //     },
    //     email: {
    //         order: 2,
    //     },
    //     phone_number: {
    //         order: 3,
    //     },
    //     password: {
    //         order: 4
    //     },
    //     confirm_password: {
    //         order: 5,
    //     },
    // }
    // const signUpAttribsProp = props.initialState === 'signUp' ? {
    //     signUp: {
    //         password: {
    //             labelHidden: false,
    //             label: 'Password:',
    //             placeholder: 'Enter your Password',
    //             isRequired: false,
    //             order: 2,
    //         },
    //         confirm_password: {
    //             labelHidden: false,
    //             label: 'Confirm Password:',
    //             order: 1,
    //         },
    //     },
    // } : {}
    // const signUpAttribsProp = props.initialState === 'signUp' ? {
    //     signUpAttributes:['given_name','email','phone_number','password','confirm_password']
    // } : {}
    const formFields = {
        // signIn: {
        //     username: {
        //         dialCode: '+353'
        //     },
        // },
        // signUp: {
        //     given_name: {
        //         order: 1,
        //     },
        //     phone_number: {
        //         order: 2,
        //         dialCode: '+353'
        //     },
        // },
    }
    return (

        <div className="amplify-classes mt-5">

            <Authenticator initialState="signIn"
                           components={components}
                          // formFields={formFields}
                           hideSignUp
                           >
                <DataStoreInitiatorAndRedirect />
            </Authenticator>
        </div>
    );
}

function DataStoreInitiatorAndRedirect(props){
    const [searchParams, setSearchParams] = useSearchParams();
    const path = searchParams.get("path")
    const [redirect,setRedirect] = useState(false)
    const [privateBrowsing,setPrivateBrowsing] = useState(false)
    useEffect(()=>{
      //  console.log('Logged In')
            const listener = Hub.listen("datastore", async hubData => {
                const {event, data} = hubData.payload;
               // console.log(event)
                if (event === "ready") {
                    listener()
                    setRedirect(true)
                }
            })
            const init = async ()=>{
                try{
                    await DataStore.start()
                }
                catch(err){
                    setTimeout(()=>{
                        setPrivateBrowsing(true)
                    },8000)
                }
            }
            init()
    },[])

    if (redirect){
        let route = !!path ? path : '/'
        return <Navigate to={route}/>
    }
    if (privateBrowsing){
        return <div className="d-flex align-items-center vh-100 text-primary text-muted text-center">

            <div className="d-flex flex-column mx-auto">
                <p>This app does not work in privacy mode</p>
            </div>


        </div>
    }
    return <SettingThingsUp/>
}

export default Login;
